import { NgModule } from '@angular/core';

import { FunctionDisplayPipe } from './function-display.pipe';

@NgModule({
  declarations: [FunctionDisplayPipe],
  exports: [FunctionDisplayPipe],
})
export class FunctionDisplayModule {}
